import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { LoginScreen } from './screens/LoginScreen';
import { ShellLayout } from './screens/ShellLayout';
import { OverviewScreen } from './screens/OverviewScreen';
import { UserLookupScreen } from './screens/UserLookupScreen';
import { User360Screen } from './screens/User360Screen';
import { CollectionsScreen } from './screens/CollectionsScreen';
import { GrowthScreen } from './screens/GrowthScreen';
import { PriceAlertsScreen } from './screens/PriceAlertsScreen';
import { SubscriptionsScreen } from './screens/SubscriptionsScreen';
import { ScannerScreen } from './screens/ScannerScreen';
import { ScanSessionsScreen } from './screens/ScanSessionsScreen';
import { PricingScreen } from './screens/PricingScreen';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<ShellLayout />}>
          <Route path="/" element={<OverviewScreen />} />
          <Route path="/users" element={<UserLookupScreen />} />
          <Route path="/users/:id" element={<User360Screen />} />
          <Route path="/collections" element={<CollectionsScreen />} />
          <Route path="/growth" element={<GrowthScreen />} />
          <Route path="/price-alerts" element={<PriceAlertsScreen />} />
          <Route path="/subscriptions" element={<SubscriptionsScreen />} />
          <Route path="/scanner" element={<ScannerScreen />} />
          <Route path="/scan-sessions" element={<ScanSessionsScreen />} />
          <Route path="/pricing" element={<PricingScreen />} />
        </Route>
      </Route>
    </Routes>
  );
}
